import { render, staticRenderFns } from "./ConsentRootComponent.vue?vue&type=template&id=77c33564"
import script from "./ConsentRootComponent.vue?vue&type=script&lang=js"
export * from "./ConsentRootComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports